import * as React from "react"
import { Link as GatsbyLink } from "gatsby"

type Props = {
  children: React.ReactNode
  href?: string
  external?: boolean
  noreferrer?: boolean
  sponsored?: boolean
  to?: string
  classes?: string
  onClick?: React.MouseEventHandler | undefined
}

const Link: React.FC<Props> = ({
  children,
  href = "",
  external = false,
  noreferrer = false,
  sponsored = false,
  to = "",
  classes = "",
  onClick = undefined,
}) => {
  if (href && external) {
    return (
      // eslint-disable-next-line react/jsx-no-target-blank
      <a
        className={"no-underline" + " " + classes}
        href={href}
        target="_blank"
        rel={[
          "noopener",
          ...(noreferrer ? ["noreferrer"] : []),
          ...(sponsored ? ["nofollow sponsored"] : []),
        ].join(" ")}
        onClick={onClick}
      >
        {children}
      </a>
    )
  } else if (href) {
    return (
      <a
        className={"no-underline" + " " + classes}
        href={href}
        onClick={onClick}
      >
        {children}
      </a>
    )
  } else {
    return (
      <GatsbyLink
        className={"no-underline" + " " + classes}
        to={to}
        onClick={onClick}
      >
        {children}
      </GatsbyLink>
    )
  }
}

export default Link
